import { Skeleton, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import { tss } from "tss-react/mui"
import { ReceiptContainer, ReceiptSkeleton } from "./ReceiptBlocks"
import { Grid } from "@mui/material"

const useStyles = tss.create(({ theme }) => ({
    section: {
        width: "100%",
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
        },
    },
    separatorBottom: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3),
    },
    header: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        textAlign: "center",
        fontWeight: 500,
        color: theme.palette.tailwind.slate[700],
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4.5),
            fontSize: theme.typography.h5.fontSize,
            lineHeight: 1.2,
            fontWeight: 700,
        },
    },
    infoItemRow: {
        borderBottom: 0,
        padding: 0,
    },
    itemEnd: {
        height: theme.spacing(2),
    },
}))

function SkeletonInfoItem({ labelWidth = 100 }: { labelWidth?: number }) {
    const { classes } = useStyles()

    return (
        <>
            <TableRow>
                <TableCell align="left" colSpan={2} className={classes.infoItemRow}>
                    <Skeleton variant="text" width={labelWidth} height={24} animation="wave" />
                </TableCell>
                <TableCell align="right" className={classes.infoItemRow}>
                    <Skeleton variant="text" width={120} height={24} animation="wave" />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={3} className={`${classes.infoItemRow} ${classes.itemEnd}`}>
                    {" "}
                </TableCell>
            </TableRow>
        </>
    )
}

function SkeletonSection({ itemCount = 4, final = false }: { itemCount?: number; final?: boolean }) {
    const { classes, cx } = useStyles()

    return (
        <Grid item className={cx(classes.section, { [classes.separatorBottom]: !final })}>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell align="left" colSpan={2} className={classes.infoItemRow}>
                            <Skeleton variant="text" width={150} height={32} animation="wave" />
                        </TableCell>
                        <TableCell align="right" className={classes.infoItemRow}>
                            <Skeleton variant="text" width={80} height={32} animation="wave" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3} className={`${classes.infoItemRow} ${classes.itemEnd}`}>
                            {" "}
                        </TableCell>
                    </TableRow>
                    {Array.from({ length: itemCount }).map((_, index) => (
                        <SkeletonInfoItem key={index} labelWidth={80 + Math.random() * 40} />
                    ))}
                </TableBody>
            </Table>
        </Grid>
    )
}

export function ReceiptDetailsSkeleton() {
    const { classes } = useStyles()

    return (
        <ReceiptContainer>
            <Grid item className={classes.section}>
                <Typography variant="h4" className={classes.header}>
                    <Skeleton variant="text" width={200} height={40} animation="wave" sx={{ margin: "0 auto" }} />
                </Typography>
            </Grid>

            <SkeletonSection itemCount={6} />
            <SkeletonSection itemCount={3} />
            <SkeletonSection itemCount={4} final />
        </ReceiptContainer>
    )
}
